<template>
  <div class="profile-widget">
    <div id="profile-tool-container"
         :disable="loading || centrelineIds.length === 0"
         :class="{'profile-toolbar': true, 'profile-toolbar-shown': profileShow}"
    >
      <b-button-group size="sm">
        <b-dropdown text="ADD" v-if="selectedCid && mode === 'current'">
          <!-- <icon name="plus-circle"></icon> -->
          <b-dropdown-item @click="addPoint($event, 'hpv')">HPV {{addingPoint === 'hpv' ? '(cancel)' : ''}}</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="addPoint($event, 'lpd')">LPD {{addingPoint === 'lpd' ? '(cancel)' : ''}}</b-dropdown-item>
        </b-dropdown>

        <!-- <b-button @click="prevStep" :disabled="!centrelineHistory.length">
          <icon name="arrow-left"></icon>
          From
        </b-button>
        <b-button @click="nextStep" :disabled="nextDisabled">To Facility
          <icon name="arrow-right"></icon>
        </b-button> -->
        <!-- <b-button @click="unscope" v-if="featuresBkp && mode">
          <icon name="plus"></icon>
        </b-button> -->
        <!--
        <b-button v-if="selectedCid && (mode === 'current' || parseInt(mode) == mode)" @click="alongRoute($event, -1)" >
          <icon name="arrow-left"></icon>
        </b-button>
        <b-button v-if="selectedCid && mode === 'current'" @click="alongRoute($event, 1)" >
          <icon name="arrow-right"></icon>
        </b-button>-->
        <b-dropdown :text="mode && mLabels[mode] ? mLabels[mode] : 'MODE'" v-if="selectedCid">
          <b-dropdown-item @click="setMode('current')">Selected centreline</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="setMode('flowline')">Up to header</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="setMode('route')">Up to facility</b-dropdown-item>
        </b-dropdown>

        <b-button :disable="loading" @click="showSearch = !showSearch">
          {{selCidLabel}}
        </b-button>
      </b-button-group>

      <b-input-group>
        <b-form-input autofocus v-if="showSearch" v-on:keyup.native="search" v-model="q"></b-form-input>
        <b-input-group-append>
          <b-btn @click="showSearch = !showSearch" :disable="loading">
            <icon name="search"></icon>
          </b-btn>
        </b-input-group-append>
      </b-input-group>

      <div class="profile-select-item-options" v-if="showAvailable && showSearch">
        <b-list-group class='profile-search-list-group'>
          <b-list-group-item href="#" v-for="(option, index) in results" @click.prevent="selectItem(option)"
                             :key="index">{{option[1]}}
          </b-list-group-item>
          <template v-if="!results.length && showNotFound">
            <li class="list-group-item bg-light"><span class="not-found-label">{{notFoundText}}</span></li>
          </template>
        </b-list-group>
      </div>
    </div>
    <svg ref="profile_svg" class="profile-svg" :style="{'cursor': addingPoint ? 'crosshair' : 'default'}"></svg>
    <loading-overlay :show="loading"></loading-overlay>
  </div>
</template>
<script>
  import store from '../../store'
  import 'vue-awesome/icons/arrow-left'
  import 'vue-awesome/icons/arrow-right'
  import 'vue-awesome/icons/print'
  import 'vue-awesome/icons/plus-circle'
  import 'vue-awesome/icons/search-minus'
  import 'vue-awesome/icons/plus'
  import WktFormat from 'ol/format/WKT'
  import GeoJSON from 'ol/format/GeoJSON'
  import clip from '@turf/bbox-clip'
  import along from '@turf/along'
  import alongSlice from '@turf/line-slice-along'
  // import buffer from '@turf/buffer'
  import zip from 'lodash-es/zip'
  import PotreeService from '../../service/potreeService'
  import {transformGeometry} from '../../util/map'

  import { select, event } from 'd3-selection'
  import { scaleLinear } from 'd3-scale'
  import { axisBottom, axisLeft } from 'd3-axis'
  import { extent } from 'd3-array'
  import { drag } from 'd3-drag'
  import { line as d3Line, symbol, symbolCircle, symbolWye } from 'd3-shape'
  // import JsPDF from 'jspdf'
  // import canvg from 'canvg-browser'
  // import asyncSeries from 'async/series'
  import * as olProj from 'ol/proj'
  import Feature from 'ol/Feature'
  import VectorLayer from 'ol/layer/Vector'
  import VectorSource from 'ol/source/Vector'
  import Fill from 'ol/style/Fill'
  import Stroke from 'ol/style/Stroke'
  import Style from 'ol/style/Style'
  import RegularShape from 'ol/style/RegularShape'
  import Point from 'ol/geom/Point'
  import LineString from 'ol/geom/LineString'
  import LoadingOverlay from '../LoadingOverlay'

  // import { EPSG_28355, EPSG_28356 } from '../../util/projections'
  // import proj4 from 'proj4'
  // import Projection from 'ol/proj/projection'
  //
  // proj4.defs('EPSG:28356', EPSG_28356)
  // proj4.defs('EPSG:28355', EPSG_28355)
  //
  // olProj.addProjection(new Projection({
  //   code: 'EPSG:28356'
  // }))
  // olProj.addProjection(new Projection({
  //   code: 'EPSG:28355'
  // }))

  export default {
    name: 'profile-viewer',
    components: {LoadingOverlay},
    created () {
      this.centrelineLayer = null
      this.centreline = null
      this.centrelineGeomBestSrid = null
      this.centrelineGeoJson = null
      this.wkt = new WktFormat()
      this.geoJson = new GeoJSON()

      let fill = new Fill({
        color: 'rgba(255, 255, 0, 0.3)'
      })
      let stroke = new Stroke({
        color: 'black',
        width: 2
      })

      let style = new Style({
        fill: fill,
        stroke: stroke,
        image: new RegularShape({
          fill: fill,
          stroke: new Stroke({
            color: '#ff0000',
            width: 2
          }),
          points: 4,
          radius: 10,
          radius2: 0,
          angle: 0
        })
      })
      let styleMarker = new Style({
        fill: fill,
        stroke: stroke,
        image: new RegularShape({
          fill: fill,
          stroke: stroke,
          points: 4,
          radius: 10,
          radius2: 0,
          angle: Math.PI / 4
        })
      })
      this.servicingLayer = new VectorLayer({
        source: new VectorSource({
          features: []
        }),
        style: (f) => {
          return f.get('marker') ? [styleMarker] : [style]
        }
      })
      this.servicingLayer.setZIndex(1)
      this.crossFeature = new Feature(new Point([0, 0]))
    },
    mounted () {
      if (this.$store.getters['map/context_centreline']) {
        this.selectedCid = this.$store.getters['map/context_centreline']
        this.mode = 'current'
      }
      else if (this.centrelineIds.length > 0) {
        this.selectedCid = this.centrelineIds[0]
      }

      this.selectCorridorShow = false
      this.$mapService.map.addLayer(this.servicingLayer)
      this.$mapService.addListener('click', this.onMapClick, this)

      if (this.currentWorkpackId) {
        this.loadCentrelineIds()
      }
      let flag = 0
      let fn = () => {
        flag++
        this.checkCentrelineLayer()
        if (!this.centrelineLayer && (flag < 30)) {
          setTimeout(() => {
            fn()
          }, 500)
        } else {
          this.layersReady = true
        }
      }

      fn()

    },
    destroyed () {
      this.$mapService.map.removeLayer(this.servicingLayer)
      this.$mapService.removeListener('click', this.onMapClick, this)
    },
    data () {
      return {
        mLabels: {
          'current': 'Selected centreline',
          'flowline': 'Up to header',
          'route': 'Up to facility'
        },
        segmentCid: null,
        segmentCidLabel: null,
        featuresBkp: null,
        addingPoint: null,
        layersReady: false,
        selCidLabel: 'Click corridor on map to see profile',
        selectedCid: null,
        selectCorridorShow: false,
        segmentGeo: null,
        points: [],
        index: 0,
        chunkIndex: 0,
        chunks: [],
        features: [],
        currentChunk: null,
        loading: false,
        prevDisabled: false,
        nextDisabled: false,
        xExtent: null,
        centrelineIds: [],
        centrelines: [],
        print: {
          pageWidth: 841.89, //pt
          pageHeight: 595.28, //pt
          padding: 10
        },
        showAvailable: true,
        notFoundText: 'Nothing found',
        showNotFound: false,
        q: '',
        showSearch: false,
        results: [],
        centrelineHistory: []
      }
    },
    watch: {
      index (val) {
        if (this.index <= 0) {
          this.prevDisabled = true
        } else {
          this.prevDisabled = false
        }

        if (this.index >= this.centrelineIds.length - 1) {
          this.nextDisabled = true
        } else {
          this.nextDisabledDisabled = false
        }
      },
      selectedCid (val) {
        if (val) {
          this.loadCentreline(val)
        }
      },
      olInitialised: {
        immediate: true,
        handler (newVal, oldVal) {
          this.$mapService.map.getView().on('change:center', () => {
            setTimeout(() => {
              this.calculateExtent()
            }, 200)
          })
          this.$mapService.map.getView().on('change:resolution', () => {
            setTimeout(() => {
              this.calculateExtent()
            }, 200)
          })
          this.$mapService.map.getView().on('change:rotation', () => {
            setTimeout(() => {
              this.calculateExtent()
            }, 200)
          })
        }
      },
      xExtent () {
        this.drawChart()
      },
      currentWorkpackId () {
        this.loadCentrelineIds()
      }
    },
    computed: {
      mapToolRightMeasureShown: {
        get () {
          return store.state.map.mapToolRightMeasureShown
        },
        set (val) {
          store.commit('setMapToolRightMeasureShown', val)
        }
      },
      mode: {
        get () {
          return store.state.map.profileMode
        },
        set (val) {
          store.commit('map/profileMode', val)
        }
      },
      olInitialised () {
        return store.getters['map/initialised']
      },
      currentWorkpackId: () => store.getters['project/currentProject'] ? store.getters['project/currentProject'].workpack.id : null,
      profileShow: {
        get () {
          return store.getters['map/profileShow']
        },
        set (val) {
          store.commit('map/profileShow', val)
        }
      },
      currentProject () {
        return store.getters['project/currentProject']
      }
    },
    methods: {
      unscope () {
        if (this.mode) {
          this.setMode(this.mode)
          return
        }
        if (this.chunksBkp) {
          this.setChunk(this.chunksBkp[0])
          this.features = this.featuresBkp
          this.chunks = this.chunksBkp

          this.chunksBkp = null
          this.featuresBkp = null
          this.featuresBkp = null
        } else {
          this.$notify({
            title: 'ERROR',
            text: 'No valid chunks found',
            type: 'error'
          })
        }

      },
      addPoint (e, type) {
        if (this.addingPoint) {
          this.uninitAddPoint()
        } else {
          this.initAddPoint(type)
        }
      },
      saveHvLpd (data) {
        this.$http.post('/api/layers/profile-point/', data).then(() => {
          this.loadCentreline(this.selectedCid, true)
        }, () => {
          this.$notify({
            title: 'ERROR',
            text: 'Unkown error',
            type: 'error'
          })
        })
      },
      initAddPoint (type) {
        this.addingPoint = type
        let me = this
        this.unintDragMode()
        this.rect.on('click.add', function () {
          me.uninitAddPoint()
          me.saveHvLpd({
            centreline_id: me.selectedCid,
            location: me.scaleX.invert(event.x),
            type: type
          })
        })
      },
      uninitAddPoint () {
        this.addingPoint = null
        this.rect.on('click.add', null)
        this.initDragMode(this, this.rect, null)
      },
      search (e) {
        if (this.q) {
          let filteredCentrelines = this.centrelines.filter(c => c[1] && c[1].toLowerCase().indexOf(this.q.toLowerCase()) > -1)
          this.results = filteredCentrelines.slice(0, 4)
        }
      },
      selectItem (val) {
        this.centrelineHistory = []
        this.selectedCid = val[0]
      },
      onMapClick (e) {
        let centreline = this.getClosestCentreline(e.coordinate)
        this.selectedCid = centreline.get('id')
        this.centrelineHistory = []
      },
      getClosestCentreline (coord) {
        this.checkCentrelineLayer()
        if (!this.centrelineLayer) {
          this.$notify({
            title: 'No Layer',
            text: 'Centreline vector layer not found. Please, add it to the project',
            type: 'warning'
          })
        }
        return this.centrelineLayer.getSource().getClosestFeatureToCoordinate(coord)
      },
      checkCentrelineLayer () {
        if (!this.$mapService) {
          return
        }
        if (!this.centrelineLayer) {
          let centrelineLayerName = 'v4:centreline'
          let layers = []
          this.$mapService.walkTree(store.getters['map/layersTree'], node => {
            if ([centrelineLayerName].indexOf(node['name']) > -1 && node['data_type'] === 'wfs') {
              layers.push(node)
            }
          })
          let countFeatures = 0
          layers.forEach(layer => {
            let exists = this.$mapService._layerExists(layer)
            if (exists && exists.getSource().getFeatures().length > countFeatures) {
              countFeatures = exists.getSource().getFeatures().length
              this.centrelineLayer = exists
            }
          })
        }
      },
      loadCentrelineIds () {
        this.loading = true
        this.$http.get('/api/layers/centreline-ids', {
          params: {
            workpack_id: this.currentWorkpackId
          }
        }).then(res => {
          this.centrelineIds = res.body.map(c => c[0])
          this.centrelines = res.body
          this.loading = false
          if (this.selectedCid) {
            this.loadCentreline(this.selectedCid)
          }
        }, res => {
          this.loading = false
          this.$notify({
            title: 'ERROR',
            text: 'Could not load centrelines id list.',
            type: 'error'
          })
        })
      },
      nextStep () {
        if (this.index < 0) {
          this.index = 0
        }

        if (this.chunkIndex < 0) {
          this.chunkIndex = 0
        }
        let chunk = this.chunks[this.chunkIndex++]
        if (this.currentChunk === chunk) {
          chunk = this.chunks[this.chunkIndex++]
        }
        if (chunk) {
          this.setChunk(chunk)
        } else {
          if (this.centreline.get('parent_id')) {
            this.centrelineHistory.push(this.selectedCid)
            this.selectedCid = this.centreline.get('parent_id')
            return
          }
          let cid = this.centrelineIds[this.index++]
          if (cid === this.selectedCid) {
            cid = this.centrelineIds[this.index++]
          }
          this.selectedCid = cid
        }
      },
      prevStep () {
        let chunk = this.chunks[--this.chunkIndex]
        if (this.currentChunk === chunk) {
          chunk = this.chunks[--this.chunkIndex]
        }
        if (chunk) {
          this.setChunk(chunk)
        } else {

          let h = this.centrelineHistory.pop()
          if (h) {
            this.selectedCid = h
            return
          }

          let cid = this.centrelineIds[--this.index]
          if (cid === this.selectedCid) {
            cid = this.centrelineIds[--this.index]
          }
          this.selectedCid = cid
        }
      },
      scopeData (x1, x2, noInv) {
        let l1 = noInv ? x1 : this.scaleX.invert(x1)
        let l2 = noInv ? x2 : this.scaleX.invert(x2)
        let elevations = []
        let locations = [...this.lbkp.filter((f, i) => {
          if (f >= l1 && f <= l2) {
            elevations.push(this.ebkp[i])
            return true
          }
          return false
        })]

        if (!locations.length) {
          return
        }

        this.featuresBkp = this.featuresBkp || this.features;
        this.chunksBkp = this.chunks;
        this.features = this.features.filter(f => f['f_location'] >= l1 && f['f_location'] <= l2)

        let chunk = {
          start: l1,
          end: l2,
          locations: locations,
          elevations: elevations
        }

        let gs = transformGeometry(this.wkt.readGeometry(this.chunks[0]['geo']), 'EPSG:3857', 'EPSG:4326')
        let geo = this.geoJson.writeGeometryObject(gs)

        geo = alongSlice(geo, locations[0]/1000, locations[locations.length - 1]/1000, {units: 'kilometers'}).geometry

        let p1 = {
          x: geo.coordinates[0][0],
          y: geo.coordinates[0][1],
        }
        let p2 = {
          x: geo.coordinates[geo.coordinates.length-1][0],
          y: geo.coordinates[geo.coordinates.length-1][1],
        }

        geo = this.geoJson.readGeometryFromObject(geo)

        chunk['geo'] = this.wkt.writeGeometryText(transformGeometry(geo,'EPSG:4326', 'EPSG:3857'))
        chunk['azimuth'] = (PotreeService.findAzimuth(p2, p1) * Math.PI)/180

        this.mixinFeatures()
        this.setChunk(chunk)
      },
      loadCentreline (cid, reload) {
        this.loading = true
        this.$http.get('/api/layers/profile-centreline/', {
          params: {
            centreline_id: cid
          }
        })
          .then(res => {
            this.loading = false
            this.results = []
            this.showSearch = false
            this.q = ''

            this.centrelineGeoJsonBkp = null
            this.centrelineBkp = null
            this.featuresBkp = null
            this.chunksBkp = null

            this.chunks = res.body['chunks']
            this.sections = res.body['chunks'][0]['sections']
            this.features = res.body['features']
            this.lbkp = [...res.body['chunks'][0].locations]
            this.ebkp = [...res.body['chunks'][0].elevations]
            this.mixinFeatures()

            this.segmentCid = this.selectedCid

            if (!reload) {
              this.chunkIndex = 0
            } else {
              this.chunkIndex--
              this.$mapService.walkTree(this.$store.getters['map/layersTree'], node => {
                if (node['name'] === 'v4:lpd' || node['name'] === 'v4:hpv') {
                  this.$mapService.forceCreateLayer(node)
                }
              })
            }

            this.setChunk(this.chunks[this.chunkIndex++])
            this.selCidLabel = this.centrelines.filter(c => c[0] === cid)[0][1]
            this.checkCentrelineLayer()
            this.centreline = new Feature(this.wkt.readGeometry(this.currentChunk['geo']))

            this.centrelineGeomBestSrid = this.centreline.getGeometry().clone().transform(olProj.get('EPSG:3857'), olProj.get('EPSG:4326'))

            this.centrelineGeoJson = this.geoJson.writeFeatureObject(new Feature({
              geometry: this.centrelineGeomBestSrid
            }))
            // Workaround to ensure mode does not change on centreline reload/change
            this.setMode(this.mode)
          }, res => {
            this.loading = false
            this.$notify({
              title: 'ERROR',
              text: 'Could not load centreline data.',
              type: 'error'
            })
          })
      },
      alongRoute (e, step) {
        e.preventDefault()
        let s = this.sections.map((f, i) => {
          return {
            id:f.id,
            i: i
          }
        } ).filter(f => f.id === this.segmentCid)[0]
        if (s && this.sections[s.i + step]) {
          this.segmentCid = this.sections[s.i + step].id
          this.segmentCidLabel = this.sections[s.i + step].ident
          this.setMode(this.segmentCid)
        } else {
          this.$notify({
            title: 'INFO',
            text: 'No more centrelines in that direction',
            type: 'info'
          })
        }
      },
      setMode (mode) {
        this.mode = mode
        let x1
        let x2
        let s

        if (parseInt(mode) == mode) {
          s = this.sections.filter(f => f.id === mode)[0]
          x1 = s.start
          x2 = s.end
          this.scopeData(x1, x2, true)
          return
        }

        this.segmentCidLabel = '';
        this.segmentCid = this.selectedCid;

        switch (mode) {
          case 'current':
            s = this.sections.filter(f => f.id === this.selectedCid)[0]
            x1 = s.start
            x2 = s.end
            break;
          case 'flowline':
            s = this.sections.filter(f => f.type !== 'header')
            if (s.length > 0) {
              x1 = s[0].start
              x2 = s[s.length-1].end
            } else {
              this.$notify({
                title: 'ERROR',
                text: 'No sections of correct type found',
                type: 'error'
              })
            }
            break;
          case 'route':
            this.mode = null
            this.unscope()
            return
        }

        this.scopeData(x1, x2, true)
      },
      setChunk (chunk) {
        this.currentChunk = chunk
        this.$mapService.map.getView().setRotation(Math.PI / 2 - parseFloat(chunk['azimuth']))
        // this.$mapService.map.getView().fit(this.wkt.readGeometry(chunk['geo']), {
        //   padding: [50, 50, 50, 50]
        // })
      },
      calculateExtent () {
        if (!this.currentChunk || !this.profileShow) {
          return
        }
        let bbox = this.$mapService.map.getView().calculateExtent(this.$mapService.map.getSize())
        let intersection = clip(
          this.geoJson.writeGeometryObject(this.wkt.readGeometry(this.currentChunk['geo'])),
          bbox
        )
        if (!intersection.geometry.coordinates.length) {
          console.log('no intersection')
          return
        }
        let center = this.$mapService.map.getView().getCenter()
        let coordinates = this._rotateCoordinates(intersection.geometry.coordinates, center[0], center[1], this.$mapService.map.getView().getRotation())
        let start = coordinates[0]
        let end = coordinates[coordinates.length - 1]
        let pixelStart = this.$mapService.map.getPixelFromCoordinate(start)
        let pixelEnd = this.$mapService.map.getPixelFromCoordinate(end)
        this.xExtent = [pixelStart[0], pixelEnd[0]]
      },
      mixinFeatures () {
        this.chunks.forEach(c => {
          let l = [...c['locations'].map(ll => parseFloat(ll))]
          let e = [...c['elevations'].map(ll => parseFloat(ll))]
          let lex = extent(l)
          let fs = this.getSegmentFeatures(lex)

          fs.forEach(f => {
            for (let i = 0; i < l.length - 1; i++) {
              if (l[i] < f['f_location'] && l[i + 1] >= f['f_location']) {
                c['locations'].splice(i + 1, 0, f['f_location'])
                c['elevations'].splice(i + 1, 0, f['f_elevation'])
              }
            }
          })
        })
      },
      getSegmentFeatures (extent) {
        return this.features.filter(f => f['f_location'] >= extent[0] && f['f_location'] <= extent[1])
      },
      drawBuffer (locationExtent) {
        this.servicingLayer.getSource().clear()

        let p1 = this.geoJson.readFeatureFromObject(along(this.centrelineGeoJson, locationExtent[0] / 1000))
        let p2 = this.geoJson.readFeatureFromObject(along(this.centrelineGeoJson, locationExtent[1] / 1000))
        p1.getGeometry().transform(olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))
        p2.getGeometry().transform(olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))
        p1.set('marker', true)
        p2.set('marker', true)
        this.servicingLayer.getSource().addFeature(p1)
        this.servicingLayer.getSource().addFeature(p2)

        // let line = new Feature(new LineString([p1.getGeometry().getCoordinates(), p2.getGeometry().getCoordinates()]))

        // let p3 = along(this.geoJson.writeFeatureObject(line), line.getGeometry().getLength()/2, {units: 'degrees'})
        // // let p3 = this.geoJson.writeFeatureObject(new Feature(new Point([(p1.getGeometry().getCoordinates()[0] + p2.getGeometry().getCoordinates()[0])/2,
        // //   (p1.getGeometry().getCoordinates()[1] + p2.getGeometry().getCoordinates()[1])/2])))
        // let b = buffer(p3, line.getGeometry().getLength()/2, {units: 'degrees'})
        // b = this.geoJson.readFeatureFromObject(b)
        // b.getGeometry().transform(olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))
        // this.servicingLayer.getSource().addFeature(b)

        // console.log(this.wkt.writeFeature(line))
        // console.log(this.wkt.writeFeature(p1))
        // console.log(this.wkt.writeFeature(p2))
        // console.log(this.wkt.writeFeature(this.geoJson.readFeatureFromObject(p3)))
      },
      drawChart () {
        let svg = select(this.$refs.profile_svg)
        svg.attr('shape-rendering', 'crispEdges')

        if (!this.bbox) {
          this.bbox = this.$refs.profile_svg.getBoundingClientRect()
        }

        let bbox = this.bbox
        let paddingBottom = 20
        let paddingTop = 20
        let height = bbox.height - paddingBottom - paddingTop
        let width = Math.abs(this.xExtent[1] - this.xExtent[0])
        svg.selectAll('*').remove()
        let sections = {
          'chart': 0.4,
          'elevation': 0.6,
          'location': 0.8,
          'name': 0.95
        }

        let sectionPadding = 5

        let locations = this.currentChunk['locations'].map(l => parseFloat(l))
        let locationExtent = extent(locations)
        let scaleX = this.scaleX = scaleLinear().domain(locationExtent).range(this.xExtent)

        let elevations = this.currentChunk['elevations'].map(l => parseFloat(l))
        let scaleY = scaleLinear().domain(extent(elevations)).range([height * sections['chart'], paddingTop])

        this.drawBuffer(locationExtent)

        let vline = svg.append('line')
          .attr('class', 'straight-line')
          .attr('stroke-width', 1)
          .attr('stroke', '#808080')
          .attr('x1', 0)
          .attr('x2', 0)
          .attr('y1', height)
          .attr('y2', 0)

        let hline = svg.append('line')
          .attr('class', 'straight-line')
          .attr('stroke-width', 1)
          .attr('stroke', '#808080')
          .attr('x1', 0)
          .attr('x2', bbox.width)
          .attr('y1', 0)
          .attr('y2', 0)

        let htext = svg.append('text')
          .attr('class', 'small-profile-label')
          .attr('x', 78)
          .attr('y', 0)
          .text('')

        let segmLabel = svg.append('text')
          // .attr('class', 'small-profile-label')
          .attr('x', 180)
          .attr('y', 25)
          .text(this.segmentCidLabel)

        svg.append('g')
          .attr('transform', 'translate(0,' + (height) + ')')
          .call(axisBottom().scale(scaleX))

        svg.append('g')
          .attr('transform', 'translate(40, 0)')
          .call(axisLeft().scale(scaleY).ticks(3))

        let line = d3Line()
          .x(function (d) { return scaleX(d[0]) })
          .y(function (d) { return scaleY(d[1]) })

        svg.append('g')
          .datum(zip(locations, elevations))
          .append('path')
          .attr('class', 'profile-line')
          .attr('stroke', '#E33510')
          .attr('fill', 'none')
          .attr('d', line)

        // hr
        for (let k in sections) {
          let elevationLineH = height * sections[k] + sectionPadding
          svg.append('g')
            .datum([[0, elevationLineH], [bbox.width, elevationLineH]])
            .append('path')
            .attr('class', 'straight-line-light')
            .attr('stroke', '#9999AE')
            .attr('d', d3Line()
              .x(function (d) { return d[0] })
              .y(function (d) { return d[1] }))

          if (k !== 'chart') {
            svg.append('text')
              .attr('x', 5)
              .attr('y', elevationLineH - 4)
              .attr('class', 'small-profile-label')
              .text(k)
          }

        }

        svg.append('g')
          .append('line')
          .attr('class', 'straight-line')
          .attr('stroke-width', 1)
          .attr('stroke', '#808080')
          .attr('x1', 75)
          .attr('y1', 0)
          .attr('x2', 75)
          .attr('y2', bbox.height)

        let segmFeatures = this.getSegmentFeatures(locationExtent)

        let fg = svg.selectAll('g.feature-line')
          .data(segmFeatures)
          .enter()
          .append('g')
          .attr('class', 'feature-line')
          .attr('stroke-width', 1)
          .attr('stroke', '#9999AE')
          .classed('small-profile-numeric-label', true)

        // vertical line
        fg.append('line')
          .attr('class', 'straight-line-light')
          .attr('stroke-width', 1)
          .attr('stroke', '#9999AE')
          .attr('x1', (d) => scaleX(d['f_location']))
          .attr('x2', (d) => scaleX(d['f_location']))
          .attr('y1', (d) => scaleY(d['f_elevation']))
          .attr('y2', height)

        //add labels
        fg
          .append('g')
          .attr('transform', (d) => {
            return `translate(${scaleX(d['f_location']) + 10}, ${height * sections['name'] + 3}) rotate(-90)`
          })
          .append('text')
          .style('text-anchor', 'start')
          .text((d) => d['f_type'].toUpperCase())

        fg
          .append('g')
          .attr('transform', (d) => {
            return `translate(${scaleX(d['f_location']) + 12}, ${height * sections['name'] + 3}) rotate(-90)`
          })
          .append('text')
          .style('text-anchor', 'start')
          .text((d) => d['f_comment'])

        fg
          .append('g')
          .attr('transform', (d) => {
            return `translate(${scaleX(d['f_location']) - 4}, ${height * sections['location'] + 3}) rotate(-90)`
          })
          .append('text')
          .style('text-anchor', 'start')
          .text((d) => parseFloat(d['f_location']).toFixed(2))

        fg
          .append('g')
          .attr('transform', (d) => {
            return `translate(${scaleX(d['f_location']) - 4}, ${height * sections['elevation'] + 3}) rotate(-90)`
          })
          .append('text')
          .style('text-anchor', 'start')
          .text((d) => parseFloat(d['f_elevation']).toFixed(2))



        let rect = this.rect = svg.append('rect')
          .attr('class', 'underlay-rect')
          .attr('x', this.xExtent[0]-10)
          .attr('y', 0)
          .attr('width', width+10)
          .attr('height', height)

        /*let rectTotal = svg.append('rect')
          .attr('class', 'underlay-rect')
          .attr('x', 0)
          .attr('y', 0)
          .attr('width', bbox.width)
          .attr('height', height)*/

        let me = this
        let mon = function () {

          vline.attr('x1', event.x)
          vline.attr('x2', event.x)

          hline.attr('y1', event.layerY)
          hline.attr('y2', event.layerY)

          htext.text(scaleY.invert(event.layerY).toFixed(2))
          htext.attr('y', event.layerY-2)


          let point = along(me.centrelineGeoJson, scaleX.invert(event.x) / 1000)
          point = me.geoJson.readFeatureFromObject(point)
          point.getGeometry()
            .transform(olProj.get('EPSG:4326'), olProj.get('EPSG:3857'))

          me.crossFeature.getGeometry().setCoordinates(point.getGeometry().getCoordinates())
          // console.log(point.getGeometry().getCoordinates())
          // console.log(scaleX.invert(event.x)/1000)
        }
        rect.on('mousemove', mon).on('mouseover', function () {
          me.servicingLayer.getSource().addFeature(me.crossFeature)
        }).on('mouseout', function () {
          me.servicingLayer.getSource().removeFeature(me.crossFeature)
        })

        let scope = null
        let sx = null
        let sy = null

        me.initDragMode(me, rect, scope)

        let colorMap = {
          'hpv': '#660099',
          'lpd': '#33CC99',
          'lpd_review': '#66ccff',
          'lpd_review_old': '#ff9900',
          'hpv_review': '#ccccff',
        }

        fg
          .append('circle')
          .style('cursor', 'move')
          .attr('cx', function (d) {
            return  scaleX(d['f_location'])
          })
          .attr('cy', height)
          .attr('r', 7)
          .attr('fill', function (d) {
            return colorMap[d.f_type]
          })
          .call(drag()
            .on("start", function () {})
            .on("drag", function () {
              select(this).attr("cx", event.x)

              vline.attr('x1', event.x)
              vline.attr('x2', event.x)

              // hline.attr('x1', event.y)
              // hline.attr('x2', event.y)
            })
            .on("end", function (d) {
              // console.log(d)
              let loc = scaleX.invert(event.x)
              d['f_location'] = loc

              me.saveHvLpd({
                centreline_id: me.selectedCid,
                location: loc,
                type: d['f_type'],
                id: d['f_id'],
              })
            }))

      },
      initDragMode: function (me, rect, scope) {
        rect.call(drag()
          .on("start", function () {
            // rect.on('mousemove', null)
            sx = event.x
            sy = event.y

            scope = svg.append('rect')
              .attr('class', 'scope-rect')
              .attr('x', event.x)
              .attr('y', event.y)
          })
          .on("drag", function () {
            scope.attr('width', Math.max(event.x - sx, 0))
            scope.attr('height', Math.max(event.y - sy, 0))
          })
          .on("end", function () {
            if (Math.abs(sx - event.x) < 2) {
              return
            }

            me.scopeData.call(me, sx, event.x )
            scope.remove()
            // me.servicingLayer.getSource().removeFeature(me.crossFeature)
          })
        )
      },
      unintDragMode: function () {
        this.rect.call(drag()
          .on("start", null)
          .on("drag", null)
          .on("end", null)
        )
      },
      _rotateCoordinates: function (points, cx, cy, angle) {
        let p = []

        points.forEach(function (v) {
          let xr = v.x
          let yr = v.y

          let x1 = cx + (xr - cx) * Math.cos(angle) - (yr - cy) * Math.sin(angle)
          let y1 = cy + (xr - cx) * Math.sin(angle) + (yr - cy) * Math.cos(angle)
          v.x = x1
          v.y = y1
          p.push(v)
        })

        return p
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/ProfileViewer.vue